
const Notification = () => {
 
 return(
  <div className="Notification">
   <img alt="Photo" />
   <span>
    <p>Подписался(ась) на вас</p>
   </span>
  </div>
 );
}
export default Notification;